export default "<ng-content select=\"tc-avatar\"></ng-content>\r\n"